var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0072119,11 C15.0072119,10.4477153 14.5594967,10 14.0072119,10 L8,10 C7.44771525,10 7,10.4477153 7,11 C7,11.5522847 7.44771525,12 8,12 L14.0072119,12 C14.5594967,12 15.0072119,11.5522847 15.0072119,11 Z",
    id: "Briefcase-path-Copy-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0140527,15 C23.0140527,14.4477153 22.5663374,14 22.0140527,14 L8,14 C7.44771525,14 7,14.4477153 7,15 C7,15.5522847 7.44771525,16 8,16 L22.0140527,16 C22.5663374,16 23.0140527,15.5522847 23.0140527,15 Z",
    id: "Briefcase-path-Copy-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9758995,19 C18.9758995,18.4477153 18.5281843,18 17.9758995,18 L8,18 C7.44771525,18 7,18.4477153 7,19 C7,19.5522847 7.44771525,20 8,20 L17.9758995,20 C18.5281843,20 18.9758995,19.5522847 18.9758995,19 Z",
    id: "Briefcase-path-Copy-7",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.263aeeec.svg";
export { ForwardRef as ReactComponent };